function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.41 6.756h20.548M15.677 54.756h-4.329c-4.173 0-7.57-3.35-7.57-7.467M21.558 54.755h-2.163M30.819 49.423h-19.47c-1.792 0-3.242-1.433-3.242-3.2V9.956c0-1.767 1.453-3.2 3.245-3.2h6.489M53.53 6.756h3.244c1.792 0 3.244 1.433 3.244 3.2v36.267",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.922 3.556h2.163c.597 0 1.081.478 1.081 1.066v8.534c0 .588-.484 1.066-1.081 1.066h-2.163a1.074 1.074 0 01-1.082-1.066V4.622c0-.588.485-1.066 1.082-1.066zM47.04 3.556h2.163c.597 0 1.081.478 1.081 1.066v8.534c0 .588-.484 1.066-1.081 1.066H47.04a1.074 1.074 0 01-1.081-1.066V4.622c0-.588.484-1.066 1.081-1.066zM8.106 21.689h51.911",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.677 28.089h8.652M29.736 28.089h8.652M43.795 28.089h8.652M15.677 35.555h8.652M15.677 43.023h8.652M34.888 49.778h20.548M29.556 35.556h8.652M29.556 42.667h8.652M43.778 35.556h8.652M43.778 43.023h8.652",
  stroke: "#4D4D4D",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgDevSameday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/dev-sameday.svg";
export { SvgDevSameday as ReactComponent };